import { noop } from 'rxjs';
import { I4BCellType, I4BColumnConfiguration, I4BGridFilterType } from './configurations';
import { getDefaultColumnsByConcept } from './default-columns.registry';
import { I4BBasicColumn, I4BColumn, I4BSelectionColumn, NameColumn, NteDeviceModelsButtonColumn } from './definitions';
import { I4bCellConcept } from './enums';
import { HeaderType, I4BColumnHeader, I4BGrid, I4BGridOptions, NteDeviceModelsGridData } from './models';
import { I4BColumnOptions } from './options';

export const GET_DEFAULT_DEVICE_MODELS_COLUMNS_FOR_NTE_DEVICE_MODELS_VIEW = (): I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] => [
  new NameColumn(
    { displayName: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.MANUFACTURER', type: HeaderType.ICON_AND_TEXT, icon: 'device' },
    {
      id: 'manufacturer',
      concept: I4bCellConcept.DEVICES,
      autoSize: true,
      isDefault: true,
      cell: { type: I4BCellType.BASIC },
      filterParams: {
        enabled: false,
        filterType: I4BGridFilterType.SET_COLUMN_FILTER
      }
    },
    { order: 1, pinned: 'left', width: 200 }
  ),
  new I4BBasicColumn(
    { displayName: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.MODEL' },
    {
      id: 'model',
      concept: I4bCellConcept.DEVICES,
      isDefault: true,
      cell: { type: I4BCellType.BASIC },
      filterParams: {
        enabled: false,
        filterType: I4BGridFilterType.SET_COLUMN_FILTER
      }
    },
    { order: 2, width: 200 }
  ),
  new I4BBasicColumn(
    { displayName: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.INTERFACES_KEYS' },
    {
      id: 'interfacesKeys',
      concept: I4bCellConcept.DEVICES,
      isDefault: true,
      cell: { type: I4BCellType.BASIC },
      filterParams: {
        enabled: false
      }
    },
    { order: 3, width: 300 }
  )
];

export class DefaultNteDeviceModelsGrid implements I4BGrid<I4BGridOptions, NteDeviceModelsGridData> {
  masterview = 'nte-device-models';
  isDefault = false;
  isUserDefault = false;
  isAppDefault = false;
  name = null;
  userId = null;
  data: NteDeviceModelsGridData = {
    response: {
      data: [],
      pagination: null
    }
  };
  gridOptions: I4BGridOptions = {
    pageSize: 100,
    multipleSelection: false,
    autoRefresh: { enabled: false },
    gridSort: [{ colId: 'name', sort: 'asc', sortIndex: 0 }],
    buttonColumn: { enabled: false, className: new NteDeviceModelsButtonColumn() },
    selectionColumn: { enabled: false, className: new I4BSelectionColumn() }
  };
  columns: I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] = [...getDefaultColumnsByConcept(this.masterview)];

  export = () => noop();
}
